import React, { useEffect } from "react";
import FingerprintJS from "@fingerprintjs/fingerprintjs";
import axiosInstance from "./Services/AxiosAPICaller";
import AppRoutes from "./Routes/AppRoutes";

import "./Styles/App.css";
import PwaInstallPrompt from "./Components/PwaInstallPrompt/PwaInstallPrompt";
import { BubbleProvider } from "./Providers/BubbleContext";

const defaultToken = process.env.REACT_APP_STRAPI_DEFAULT_TOKEN;

if (!defaultToken) {
  console.error("No default token found in .env file");
} else if (defaultToken === "") {
  console.error("Default token is empty in .env file");
} else {
  if (defaultToken && !localStorage.getItem("DefaultStrapiToken")) {
    localStorage.setItem("DefaultStrapiToken", defaultToken);
  } else if (defaultToken !== localStorage.getItem("DefaultStrapiToken")) {
    localStorage.setItem("DefaultStrapiToken", defaultToken);
  }
}

const App: React.FC = () => {
  useEffect(() => {
    const trackVisitor = async () => {
      try {
        let visitorId = localStorage.getItem("visitorId");
        if (!visitorId) {
          const fp = await FingerprintJS.load();
          const result = await fp.get();
          visitorId = result.visitorId;
          localStorage.setItem("visitorId", visitorId);
        }
        await axiosInstance.post("/visitor-tracking", { visitorId, eventType: "session" });
      } catch {
        // Silently fail — don't break user experience
      }
    };
    trackVisitor();
  }, []);

  return (
    <BubbleProvider>
      <div className="App">
        <div className="containerMobileStyle">
          <PwaInstallPrompt />
          <AppRoutes />
        </div>
      </div>
    </BubbleProvider>
  );
};

export default App;
